import { InjectionToken, inject } from '@angular/core';
import { NotificationHubService } from './notification.hub.service';

export const NOTIFICATION_SIGNALR_HUB =
    new InjectionToken<NotificationHubService>('NOTIFICATION_SIGNALR_HUB', {
        providedIn: 'root',
        factory: () => inject(NotificationHubService),
    });
